import ValidatorService from "@/services/ValidatorService";
import NotificationServicesService from "@/services/NotificationServicesService";

const state = {
  testJobId: null,
  projectId: null,
  formGeneral: {
    name: null,
    timeout: null,
    status: null,
  },

  formNotificationService: {
    notificationService: {
      error: {notificationConfig: {}},
      warning: {notificationConfig: {}}
    },
    notificationServiceConfig: {
      error: {},
      warning: {}
    }
  },

  formValidator: {
    validators: []
  },

  formTestType: {
    testType: {testMethod: {testConfig: {}}},
    testTypeConfig: {}
  },
}

const getters = {
  formGeneral: state => {
    return state.formGeneral
  },

  formNotificationService: state => {
    return state.formNotificationService
  },

  formValidator: state => {
    return state.formValidator
  },

  formTestType: state => {
    return state.formTestType
  },

  testJobRequestData: state => {
    let notificationServices = {};
    let validators = [];

    for (let validatorItem of state.formValidator.validators) {
      if (validatorItem.validator._id) {
        validators.push({
          id: validatorItem.validator._id,
          validatorConfig: validatorItem.config
        })
      }
    }

    if (state.formNotificationService.notificationService.error._id) {
      notificationServices.error = {
        notificationServicesId: state.formNotificationService.notificationService.error._id,
        config: state.formNotificationService.notificationServiceConfig.error
      }
    }

    if (state.formNotificationService.notificationService.warning._id) {
      notificationServices.warning = {
        notificationServicesId: state.formNotificationService.notificationService.warning._id,
        config: state.formNotificationService.notificationServiceConfig.warning
      }
    }

    return {
      projectId: state.projectId,
      name: state.formGeneral.name,
      testType: state.formTestType.testType._id,
      testConfig: state.formTestType.testTypeConfig,
      notificationServices: notificationServices,
      timeout: state.formGeneral.timeout,
      totalFailedInRow: 0,
      status: state.formGeneral.status,
      validators: validators
    }
  }
}

const actions = {
  addValidator(context) {
    context.commit('addValidator')
  },

  removeValidator(context, index) {
    context.commit('removeValidator', index)
  },

  setProjectId (context, projectId) {
    context.commit('setProjectId', projectId)
  },

  setForUpdate(context, testJob) {
    context.commit('setForUpdate', testJob)
  }
}

const mutations = {
  addValidator (state) {
    state.formValidator.validators.push({
      validator: {validatorConfig:{}},
      config:{}
    })
  },

  removeValidator (state, index) {
    state.formValidator.validators.splice(index, 1)
  },

  setProjectId (state, projectId) {
    state.projectId = projectId;
  },

  setForUpdate (state, testJob) {
    state.testJobId = testJob._id;
    state.formGeneral.name = testJob.name;
    state.formGeneral.status = testJob.status;
    state.formGeneral.timeout = testJob.timeout;

    state.formTestType.testType = testJob.testType;
    state.formTestType.testTypeConfig = testJob.testConfig ? testJob.testConfig : {};

    for (let testTypeValidator of testJob.validators) {
      ValidatorService.get(testTypeValidator.id).then(response => {
        state.formValidator.validators.push({
          validator: response.data,
          config: testTypeValidator.validatorConfig
        })
      })
    }

    if (testJob.notificationServices && testJob.notificationServices.error) {
      NotificationServicesService.get(testJob.notificationServices.error.notificationServicesId)
        .then(response => {
          state.formNotificationService.notificationService.error = response.data;
          state.formNotificationService.notificationServiceConfig.error = testJob.notificationServices.error.config
        })
    }

    if (testJob.notificationServices && estJob.notificationServices.warning) {
      NotificationServicesService.get(testJob.notificationServices.warning.notificationServicesId)
        .then(response => {
          state.formNotificationService.notificationService.warning = response.data;
          state.formNotificationService.notificationServiceConfig.warning = testJob.notificationServices.warning.config
        })
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions
}
